import type { ReactNode } from 'react'
import type { AnalysisHealth } from '../../types/analysis'
import { StatusChip } from '../Common'
import { analysisHealthTone } from './analysisHealthTone'

export const AnalysisScoreRing = ({ score, state, compact = false, compactScaleLabel }: { score: number; state: AnalysisHealth['state']; compact?: boolean; compactScaleLabel?: ReactNode }) => {
  const radius = 52
  const circumference = 2 * Math.PI * radius
  const progress = Math.max(0, Math.min(100, score))
  return <div className={`analysisScore__visual${compact ? ' analysisScore__visual--compact' : ''}`} aria-label={`Workspace health ${score} out of 100`}>
    <svg className="analysisScore__svg" viewBox="0 0 128 128" aria-hidden="true">
      <circle className="analysisScore__track" cx="64" cy="64" r={radius} />
      <circle className="analysisScore__progress" cx="64" cy="64" r={radius} strokeDasharray={circumference} strokeDashoffset={circumference - (progress / 100) * circumference} />
    </svg>
    <strong>{score}</strong>
    {compact ? (
      <span className="analysisScore__stateLine">
        <StatusChip tone={analysisHealthTone(state)} size="sm" icon={<i aria-hidden="true" />}>{state}</StatusChip>
        {compactScaleLabel ? <span className="analysisScore__scale">{compactScaleLabel}</span> : null}
      </span>
    ) : <StatusChip tone={analysisHealthTone(state)} icon={<i aria-hidden="true" />}>{state}</StatusChip>}
  </div>
}
